export const view04ImageOptions = {
  angle: 'view04',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    TeakOnBathingPlatform: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    CockpitTable: 1,
    SelfTacker: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: 'BathingPlatform'
    },
    {
      option: 'Deck',
      dependency: 'SelfTacker'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'CockpitTable',
      dependency: 'Wheel'
    },
    {
      option: 'Sprayhood',
      dependency: 'BoomCover'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/view04.js